/**
 * @generated SignedSource<<aaf4c0379d2daba38509f6676391a309>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StoreTier = "basic" | "free" | "light" | "premium" | "standard" | "unlimited";
import { FragmentRefs } from "relay-runtime";
export type useHasFeatureInTier_Store$data = {
  readonly tier: StoreTier;
  readonly " $fragmentType": "useHasFeatureInTier_Store";
};
export type useHasFeatureInTier_Store$key = {
  readonly " $data"?: useHasFeatureInTier_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHasFeatureInTier_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useHasFeatureInTier_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "0a8b17b0980ead17ed2a9b673794739c";

export default node;
